<template>
    <div v-if="!iFrameAuthPopup">
        <iframe :src="iFrameSrc" :width="iFrameWidth" :height="height" :name="iFrameName"></iframe>
    </div>
    <div v-else>
        <div class="ontop" dir="ltr" id="popDiv">&nbsp;</div>
        <div dir="ltr" id="content">
            <iframe
                :height="height"
                id="iFrameCognos"
                sandbox="allow-same-origin allow-forms allow-modals allow-popups allow-scripts allow-top-navigation allow-scripts"
                src=""
                width="100%"
            ></iframe>
        </div>
    </div>
</template>

<script>
import { api } from '@/utils/api';
export default {
    props: ['dashboardId'],
    data() {
        return {
            iFrameSrc: null,
            iFrameName: null,
            iFrameWidth: null,
            iFrameHeight: null,
            iFrameAuthPopup: true,
            winRef: null,
            urlTarget: '',
            height: window.innerHeight
        };
    },
    // used to adjust the height of the iframe
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    //used to adjust the height of the iframe
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        //used to resize height
        handleResize() {
            const heigthHeader = this.$store.getters.getHeigthHeader || 0;
            const heigthFooter = this.$store.getters.getHeigthFooter || 0;
            this.height = window.innerHeight - heigthHeader - heigthFooter;
        },
        async setiFrame() {
            let service = this.getService()?.includes('IFRAME') ? 'generciIframe' : `iframe${this.getService()}`;
            const iFrame = await api.get(service, {
                clientId: this.getClientId(),
                dashboardId: this.dashboardId,
                instanceId: this.dashboardId,
                serviceNumber: this.getIframeServiceNumber()
            });
            this.iFrameSrc = iFrame.iframeSrc || '';
            this.iFrameName = iFrame.name || 'undefined';
            this.iFrameWidth = iFrame.width || '100%';
            this.iFrameHeight = this.height || iFrame.height || '650px';
            this.iFrameAuthPopup = iFrame.cognos || false;
            this.urlTarget = iFrame.authUrl || '';
            if (this.iFrameAuthPopup) {
                this.displayPopup();
            }
        },
        displayPopup() {
            this.pop('popDiv');
            this.authentification(this.winRef);

            document.onkeydown = function (evt) {
                evt = evt || window.event;
                if (evt.keyCode === 27) {
                    this.hide('popDiv');
                }
            };
        },
        authentification() {
            this.winRef = window.open(this.urlTarget, '_blank', 'width=500px,height=500px,resizable=yes');
            this.winRef.blur();
            self.focus();
            setTimeout(this.authentificationComplet(), 6000);
        },
        loadframe() {
            document.getElementById('iFrameCognos').src = this.urlTarget;
            this.hide('popDiv');
        },
        authentificationComplet() {
            if (false === this.winRef.closed) {
                this.winRef.close();
            }
            this.loadframe();
        },
        pop(div) {
            document.getElementById(div).style.display = 'block';
        },
        hide(div) {
            document.getElementById(div).style.display = 'none';
        },
        getService() {
            return this.$store.getters.getServiceName;
        },
        getClientId() {
            return this.$store.getters.getCurrentClientId;
        },
        getIframeServiceNumber() {
            return this.$store.getters.getIframeServiceNumber;
        }
    },
    async mounted() {
        this.setiFrame();
    }
};
</script>
